const awsCognitoConfig = {
  aws_cognito_identity_pool_id: "ap-southeast-2:90f64d0c-a7bf-4de4-93c5-10a517b8a726",
  aws_cognito_region: "ap-southeast-2",
  aws_user_pools_id: "ap-southeast-2_9z5aths8m",
  aws_user_pools_web_client_id: "8pff76co3por09kic5fu598kv",
  oauth: {},
};

export default awsCognitoConfig;
